import React from "react";
import * as contributorApi from "../../../../api/contributorApi";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  getMindfile,
  getCurrentUserMindfiles,
} from "../../../../state/actions/getDataActions";
import { Box, Typography, Button } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  button: {
    marginRight: 12,
    marginTop: 16,
  },
}));

function RespondRequest({
  name,
  requestId,
  close,
  mindfile,
  user,
  getMindfile,
  getCurrentUserMindfiles,
}) {
  const classes = useStyles();

  const acceptRequest = () => {
    contributorApi
      .allowContributorRequest(mindfile.id, requestId, user.authenticity_token)
      .then(() => {
        getMindfile(mindfile.id);
        getCurrentUserMindfiles();
      })
      .catch(error => console.error(error))
      .finally(close);
  };

  const declineRequest = () => {
    contributorApi
      .denyContributorRequest(mindfile.id, requestId, user.authenticity_token)
      .then(() => {
        getMindfile(mindfile.id);
        getCurrentUserMindfiles();
      })
      .catch(error => console.error(error))
      .finally(close);
  };

  return (
    <Box>
      <Typography variant="h6">Respond to this request</Typography>
      <Box mt={3} />
      <Typography>
        <b>{name}</b> have requested to join this mindfile as a contributor.
      </Typography>
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        onClick={acceptRequest}
      >
        Accept
      </Button>
      <Button
        className={classes.button}
        variant="contained"
        onClick={declineRequest}
      >
        Decline
      </Button>
      <Button
        className={classes.button}
        variant="contained"
        color="secondary"
        onClick={close}
      >
        Cancel
      </Button>
    </Box>
  );
}

const mapStateToProps = state => ({
  mindfile: state.mindfile,
  user: state.auth,
});

const mapDispatchToProps = {
  getMindfile,
  getCurrentUserMindfiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(RespondRequest);
